import type { BillingInfoFormValues, TaxInfo } from './types';
import { EventBus } from '../../helpers';

type BillingInfoFormEvents = {
  taxInfoUpdated: [taxInfo: TaxInfo];
  formDirtyStateChanged: [isDirty: boolean];
  countryUpdated: [newCountry: string, isB2bCountry: boolean];
  isVatEuCountry: [isVatEu: boolean];
  missingFields: [(keyof BillingInfoFormValues)[]];
};

class BillingInfoFormEventBus extends EventBus<BillingInfoFormEvents> {}

export const billingInfoFormEventBus = new BillingInfoFormEventBus();
